import { parseArgv } from '../args/parse-argv';
import { parseEnv } from '../env/parse-env';

/**
 * Retrieves just the vulnerabilities identified in the supplied varargs tokens
 * and environment variables.
 */
export function vulnerabilityCheck(tokens: readonly string[], env: Record<string, unknown>) {
   return [...parseArgv(...tokens).vulnerabilities, ...parseEnv(env).vulnerabilities];
}
